module.exports = __webpack_public_path__ + "img/addNew.12af8394.png";